import React, { useRef, useEffect } from 'react';
import '../../Styles/ReusableComponents/popupDefaultSmall.scss';

/**
 * A reusable popup background component that handles closing when clicking outside
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display inside the popup (your custom popup component)
 * @param {Function} props.onClose - Function to call when popup should close
 * @param {Object} props.style - Optional additional styles for the background
 */
const PopupDefaultSmall = ({ children, onClose = {} }) => {
  const popupRef = useRef(null);

  useEffect(() => {
    // Handle click outside of popup content
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="popup-default-small">
      <div
        ref={popupRef}
        className="popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

const CloseButton = ({ onClose = {} }) => {
  return (
    <button className="close-btn" onClick={onClose}>
      <svg width={30} height={30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.2} stroke="#211f1c">
        {/* <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /> */}
        
        {/* circle */}
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="currentColor" />

        {/* cross */}
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75 14.25 14.25M14.25 9.75 9.75 14.25" stroke="currentColor" />
      </svg>
    </button>
  );
};

export { PopupDefaultSmall, CloseButton };